import { render } from "./DmccComponent.vue?vue&type=template&id=4894c97a"
import script from "./DmccComponent.vue?vue&type=script&lang=js"
export * from "./DmccComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__